export default [
    {
		path: "/reports/home",
		component: () => import("../views/Reports/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/report/:reportid?/:studentid?",
		component: () => import("../views/Reports/Report.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/report/timeseries",
		component: () => import("../components/Reports/TimeSeries.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/aggregated/:reportid?/:programme?/:year?/:group?",
		component: () => import("../views/Reports/Aggregated.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/activity/:reportid?/:studentid?",
		component: () => import("../views/Reports/Activity.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/saved/list",
		component: () => import("../views/Reports/Saved/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/reports/saved/report/:reportid?",
		component: () => import("../views/Reports/Saved/Report.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/reports/attendance",
		component: () => import("../views/Reports/Attendance.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/report/htmlreport/individual/:studentid",
		component: () => import("../views/Reports/HtmlReportIndividual.vue"),
		meta: {
			hasmainmenu: false
		}
	}
]
